import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SvgIconComponent } from 'angular-svg-icon';
import { ModalModule } from 'ngx-bootstrap/modal';
import { environment } from '../environments/environment';
import { FooterComponent } from './assessment/components/common/footer/footer.component';
import { NavbarComponent } from './assessment/components/common/navbar/navbar.component';
import { ConclusionComponent } from './assessment/components/conclusion/conclusion.component';
import { InitiationComponent } from './assessment/components/initiation/initiation.component';
import { IntroductionComponent } from './assessment/components/introduction/introduction.component';
import { OverviewComponent } from './assessment/components/overview/overview.component';
import { SymbolsComponent } from './assessment/components/testlets/symbols/symbols.component';
import { APP_CONFIG, AppConfig } from './assessment/models/app-config';
import { AssessmentService } from './assessment/services/assessment.service';
import { AssessmentPlayerService } from './assessment/services/player.service';
import { TimeTrackingService } from './assessment/services/time-tracking.service';

const config: AppConfig = {
  debounceTime: environment.debounceTime || 250,
};

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    SvgIconComponent,
    InitiationComponent,
    IntroductionComponent,
    OverviewComponent,
    SymbolsComponent,
    ConclusionComponent,
    ModalModule,
    NavbarComponent,
    FooterComponent,
  ],
  providers: [
    AssessmentPlayerService,
    TimeTrackingService,
    AssessmentService,
    { provide: APP_CONFIG, useValue: config },
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'aptem.assess.app';
}
